function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { Boundary } from 'react-suspense-boundary';
import { PageLoading, renderError } from './PageStatus';
import { jsx as _jsx } from "react/jsx-runtime";
export function PageBoundary(props) {
  return /*#__PURE__*/_jsx(Boundary, _objectSpread(_objectSpread({
    pendingFallback: /*#__PURE__*/_jsx(PageLoading, {}),
    renderError: renderError
  }, props), {}, {
    children: props.children
  }));
}
PageBoundary.displayName = "PageBoundary";
export var withPageBoundary = function withPageBoundary(C) {
  // eslint-disable-next-line react/function-component-definition
  var Res = function Res(props) {
    return /*#__PURE__*/_jsx(PageBoundary, {
      children: /*#__PURE__*/_jsx(C, _objectSpread({}, props))
    });
  };

  return Res;
};
//# sourceMappingURL=es/PageBoundary/PageBoundary.js.map